import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Button,
  Space,
  Tag,
  Typography,
  message,
} from "antd";
import dayjs from "dayjs";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";

const { Text } = Typography;
const { TextArea } = Input;

const fullName = (g) =>
  `${g?.SNAM || ""}${g?.NAME1 || ""} ${g?.NAME2 || ""}`.trim();

const RecordAverageModal = ({ open, onClose, group, onSuccess }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  // ✅ prefill (รองรับทั้งกรณีเปิดครั้งแรก และแก้ไขข้อมูลเดิม)
  useEffect(() => {
    if (open) {
      const prev = group?.averageData;
      form.setFieldsValue({
        redCaseNo: prev?.redCaseNo || group?.redCaseNo || "",
        amount: prev?.amount ?? null,
        averageDate: prev?.averageDate ? dayjs(prev.averageDate) : null,
        note: prev?.note || "",
      });
    }
  }, [open, group, form]);

  const handleFinish = async (values) => {
    const data = {
      redCaseNo: values.redCaseNo,
      amount: Number(values.amount),
      averageDate: values.averageDate
        ? dayjs(values.averageDate).format("YYYY-MM-DD")
        : null,
      note: values.note || "",
    };

    try {
      setSubmitting(true);
      // TODO: เรียก API จริงตรงนี้
      // await axios.post(POST_RECORD_AVERAGE, { groupKey: group.groupKey, ...data }, { headers: HEADERS_EXPORT_BEN });
      console.log("📤 average payload:", { group: group?.groupKey, ...data });
      onSuccess?.({ group, data });
      message.success("บันทึกข้อมูลเฉลี่ยสำเร็จ");
      onClose(false);
    } catch (error) {
      console.error("❌ Error:", error);
      message.error(error.response?.data?.message || "บันทึกไม่สำเร็จ");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="บันทึกข้อมูลเฉลี่ยทรัพย์"
      open={open}
      onCancel={() => onClose(false)}
      footer={null}
      width={560}
      destroyOnHidden
    >
      <Space wrap size={8} style={{ marginBottom: 12 }}>
        <Tag>{group?.contno}</Tag>
        <Text type="secondary">{fullName(group)}</Text>
      </Space>

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="เลขคดีแดง"
          name="redCaseNo"
          rules={[{ required: true, message: "กรุณาระบุเลขคดีแดง" }]}
        >
          <Input placeholder="เช่น พ.123/2567" allowClear />
        </Form.Item>

        <Form.Item
          label="จำนวนเงินที่เฉลี่ยได้ (บาท)"
          name="amount"
          rules={[
            { required: true, message: "กรุณาระบุจำนวนเงิน" },
            { type: "number", min: 0, message: "ต้องไม่ติดลบ" },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            placeholder="ระบุจำนวนเงิน"
            formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(v) => v.replace(/,/g, "")}
          />
        </Form.Item>

        <Form.Item label="วันที่เฉลี่ย/รับเงิน" name="averageDate">
          <ThaiDatePicker style={{ width: "100%" }} placeholder="เลือกวันที่" />
        </Form.Item>

        <Form.Item label="หมายเหตุ" name="note">
          <TextArea
            rows={3}
            maxLength={300}
            showCount
            placeholder="ระบุหมายเหตุ (ถ้ามี)"
          />
        </Form.Item>

        <div style={{ textAlign: "center", marginTop: 8 }}>
          <Button
            onClick={() => onClose(false)}
            style={{ marginRight: 16 }}
            size="large"
          >
            ปิด
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={submitting}
          >
            บันทึก
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default RecordAverageModal;
